import { gql } from "@apollo/client";

export const CONFIRM_PHONE = gql`
  mutation confirmPhone($code: String!) {
    confirmPhone(input: {code: $code})
  }
`;
